'use strict';

import {debounce} from '../utils/debounce';
import layout from '../ui/layout';
import logger from '../utils/logger';

const callbacks = [];
let previousSize;

function processScreenSize() {
	let newSize = layout.getScreenSize();
	if (newSize !== previousSize) {
		previousSize = newSize;
		logger.debug('Screen size change');
		for (let index = 0; index < callbacks.length; index++) {
			const callback = callbacks[index];
			callback();
		}
	}
}

const onWindowResize = debounce(processScreenSize, 100);

export default {
	onChange: function(func) {
		if ($.isFunction(func)) {
			callbacks.push(func);
		}
	},

	start: function() {
		previousSize = layout.getScreenSize();
		$(window).off('resize.screenSizeWatcher').on('resize.screenSizeWatcher', function () {
			onWindowResize();
		});
	}
};